import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { OdooFicha, OdooFichaAccionRespuesta, OdooFichaCambios, OdooFichaMovimiento } from './odoo-ficha.models';
import { OdooRespuesta } from './odoo.models';

/** «Gestión en Odoo» de la ficha del cliente. Permisos: contactos.gestion_odoo.read / .write (los exige el servidor). */
@Injectable({ providedIn: 'root' })
export class OdooFichaService {
  private readonly base = `${environment.BASE_LA}/api/odoo/ficha`;

  constructor(private http: HttpClient) {}

  private url(code: string, resto = ''): string { return `${this.base}/${encodeURIComponent(code)}${resto}`; }

  ficha(code: string): Observable<OdooFicha> {
    return this.http.get<OdooRespuesta<OdooFicha>>(this.url(code)).pipe(map((r) => r.data));
  }

  /** Revisa y deja la línea «Revisar» en el historial. */
  revisar(code: string): Observable<OdooFicha> {
    return this.http.post<OdooRespuesta<OdooFicha>>(this.url(code, '/revisar'), {}).pipe(map((r) => r.data));
  }

  anotar(code: string): Observable<OdooFichaAccionRespuesta> {
    return this.http.post<OdooRespuesta<OdooFichaAccionRespuesta>>(this.url(code, '/anotar'), {}).pipe(map((r) => r.data));
  }

  actualizar(code: string, cambios: OdooFichaCambios): Observable<OdooFichaAccionRespuesta> {
    return this.http.patch<OdooRespuesta<OdooFichaAccionRespuesta>>(this.url(code, '/actualizar'), cambios).pipe(map((r) => r.data));
  }

  movimientos(code: string, limit = 30): Observable<OdooFichaMovimiento[]> {
    return this.http
      .get<OdooRespuesta<OdooFichaMovimiento[]>>(this.url(code, '/movimientos'), { params: new HttpParams().set('limit', String(limit)) })
      .pipe(map((r) => r.data));
  }
}
